import { Injectable } from '@angular/core';
import { AppStateService } from 'core/app-state/app-state.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { AppInfoService } from '../app-info/app-info.service';

@Injectable({
  providedIn: 'root'
})
export class ExportUtilsService {
  private appStrings: AppLocalization;

  constructor(
    private appInfoService: AppInfoService,
    private appStateService: AppStateService
  ) {
    this.appStrings = this.appInfoService.appStrings;
  }

  downloadFile(byteArray: ArrayBuffer, fileName: string) {
    // create the URL
    const url = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/octet-stream' }));
    const link = document.createElement('a');

    // set link attributes and append it to the body
    link.setAttribute('style', 'display: none');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);

    // initiate download
    link.click();

    // clean-up memory and element
    window.URL.revokeObjectURL(url);
    link.remove();
  }

  /**
   * Opens a new window
   */
  openPrintFile(innerText?: string) {
    if (!this.appStateService.state.isElectron) {
      const printWindow = window.open('', '_blank');
      printWindow.document.title = this.appStrings.loading;
      printWindow.document.body.innerHTML =
        innerText ? innerText : this.appStrings.export_quoteIsProcessing;
      return printWindow;
    }
  }

  /**
   * Prepares a BLOB file
   * @param byteArray - The byte array from the server
   * @param windowRef - The opened window where the pdf will be shown
   */
  printFile(byteArray: BlobPart, windowRef: Window) {
    const fileUrl = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/pdf' }));
    if (!this.appStateService.state.isElectron) {
      windowRef.location.href = fileUrl;
    } else {
      window.open(fileUrl);
    }
  }

}
